var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("Taiwan Tourguide "),_c('sup',[_vm._v("®")]),_vm._v(" Code: JohnLu / Design:KT / Api:交通部PTX")])])}]

export { render, staticRenderFns }